import { useEffect, useState } from "react";

export const useRoomForFrozenColumns = (minimumRem: number) => {
  const [scroller, setScroller] = useState<HTMLElement | null>(null);
  const [hasRoom, setHasRoom] = useState(true);

  useEffect(() => {
    if (!scroller) return;

    const measure = () => {
      const width = scroller.clientWidth;
      // A region that has not been laid out reports 0, which says nothing about the room there is.
      if (width === 0) return;
      const rootFontSize =
        parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      setHasRoom(width >= minimumRem * rootFontSize);
    };

    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(scroller);
    return () => observer.disconnect();
  }, [scroller, minimumRem]);

  return { ref: setScroller, hasRoom };
};
